module.exports = __webpack_public_path__ + "static/liva-pastacilik-basari-video-f5047e4885c558183b0ae931f11fbf44.mp4";